import React, {FC, ReactNode, useState} from "react";
import {faCircleNotch, IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface OnClickAction {
  icon: IconDefinition
  variant?: 'primary' | 'secondary' | 'danger'
  text?: string
  onClick: () => void|Promise<void>
}

interface CardProps {
  children: React.ReactNode
  title?: string
  actions?: OnClickAction[]
}

export const Card: FC<CardProps> = ({children, title, actions}) => {
  return <div data-slot="card" className={"bg-white text-black rounded-xs border border-gray-200 my-8"}>
    {(title || actions) && (
      <header className={"h-14 px-6 border-b border-gray-200 font-medium flex items-center space-x-1"}>
        {title && <div className={'flex-1'}>{title}</div>}
        {actions?.map((action, i) => {
          return <CardHeaderAction action={action} key={i} />
        })}
      </header>
    )}
    <div className={"py-4 px-6"}>
      {children}
    </div>
  </div>
}

function CardHeaderAction ( props: {action: OnClickAction } ): ReactNode {
  const [loading, setLoading] = useState<boolean>(false)
  const buttonStyle = {
    'primary': 'bg-blue-800 text-white hover:bg-blue-700',
    'secondary': 'bg-transparent text-blue-700 hover:bg-blue-200',
    'danger': 'bg-red-800 text-white hover:bg-red-700',
  }[props.action.variant ?? 'secondary']
  const clickAction = async () => {
    setLoading(true)
    await props.action.onClick()
    setLoading(false)
  }
  return <button className={`rounded-xs ${buttonStyle} font-medium text-sm px-2 py-1`} onClick={clickAction}>
    <FontAwesomeIcon icon={loading ? faCircleNotch : props.action.icon} spin={loading} className={props.action.text !== undefined ? 'mr-2' : ''} />
    {props.action.text !== undefined ? <span>{props.action.text}</span> : <></>}
  </button>
}
